import { DataAnalyticsTaggingEvents, DataAnalyticsTaggingEventType } from '@tdwb/core';

const marketsTabNames = [ 'overview', 'indices', 'sectors', 'news', 'reports', 'analystscenter', 'events', 'technicalinsight' ];
export class IntegrationAnalytics {

  static marketsTaggingEvents: DataAnalyticsTaggingEvents = this.addMarketsEvents();

  //TODO: convert this to a function if have time, not important though
  static investmentsTaggingEvents: DataAnalyticsTaggingEvents = {
    pageFixed_Income: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'fixed-income',
        subSection1: 'page',
        subSection2: 'fixed-income',
        customPageName: 'wb_trading-fixed-income'
      }
    },
    pageResearchStocksOverview:{
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'stocks',
        subSection1: 'investments',
        subSection2: 'stocks',
        customPageName: 'wb_investments-stocks'
      }
    },
    pageResearchStocksOptions:{
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'options',
        subSection1: 'investments',
        subSection2: 'options',
        customPageName: 'wb_investments-options'
      }
    },
    pageResearchMutualfundsOverview:{
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'mutual funds',
        subSection1: 'investments',
        subSection2: 'mutual funds',
        customPageName: 'wb_investments-mutual-funds'
      }
    },
    pageResearchEtfsOverview:{
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'etfs',
        subSection1: 'investments',
        subSection2: 'etfs',
        customPageName: 'wb_investments-etfs'
      }
    },
    pageGic_Rate_Sheet: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'gic-rate-sheet',
        subSection1: 'investments',
        subSection2: 'gic-rate-sheet',
        customPageName: 'wb_investments-gic-rate-sheet'
      }
    }
  };

  static toolsTaggingEvents: DataAnalyticsTaggingEvents = {
    modalWatchlistSingleQuotes: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'quotes',
        subSection1: 'tools',
        subSection2: 'quotes',
        customPageName: 'wb_modal-quotes'
      }
    },
    modalWatchlistSingleWatchlists: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'watchlists',
        subSection1: 'tools',
        subSection2: 'watchlists',
        customPageName: 'wb_modal-watchlists'
      }
    },
    pageResearchStocksCharts:{
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'research',
        subSection1: 'stocks',
        subSection2: 'charts',
        customPageName: 'wb_research-investments-charts'
      }
    },

    pageResearchScreenerStocks:{
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'research',
        subSection1: 'screener',
        subSection2: 'stocks',
        customPageName: 'wb_research-investments-screener'
      }
    },

    pageResearchAlertsMyalerts:{
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'research',
        subSection1: 'alerts',
        subSection2: 'myAlerts',
        customPageName: 'wb_research-investments-alerts'
      }
    }
  };

  static taggingEvents: DataAnalyticsTaggingEvents = {
    ...this.marketsTaggingEvents,
    ...this.investmentsTaggingEvents,
    ...this.toolsTaggingEvents
  }

  private static addMarketsEvents(): DataAnalyticsTaggingEvents{
    const marketEvents: DataAnalyticsTaggingEvents = {};
    marketsTabNames.forEach((tabName: string)=>{
      marketEvents[`page.research.markets.${tabName}`] = {
        event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
        page: {
          name: tabName,
          subSection1: 'markets',
          subSection2: tabName,
          customPageName: `wb_markets-${tabName}`
        }
      };
    });
    return marketEvents;
  }
}
